import { LAYOUTS, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { AspectRatioToken, ColorTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { getParameters, isMobile, removeUrlWithoutReload } from '../../configs/utils';
import { Platform } from "react-native";
import { partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader, getAuthHeaders } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import { navigateByUrl } from "../partnerWeb_Dashboard/utils";
const _isMobile = isMobile();
export const template = async () => ({
    layout: {
        id: ROUTE.PARTNER_AUTH,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [{ id: 'partnerAuthContainer', type: WIDGET.STACK }],
    },
    datastore: {
        partnerAuthContainer: {
            type: StackType.column,
            width: StackWidth.FULL,
            height: StackHeight.FULL,
            bgColor: ColorTokens.Primary_02,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            padding: {
                right: SizeTypeTokens.XL,
                left: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'partnerAuthContainerLottie', type: WIDGET.LOTTIE },
            ]
        },
        partnerAuthContainerLottie: {
            size: LottieSizeTokens.XXXL,
            aspectRatio: AspectRatioToken.A1_1,
            uri: LottieTokens.SSOLogin,
        }
    },
});
export const PartnerAuthPage = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    onLoad: async ({ openNewTab, asyncStorage, network, ...props }) => {
        let params = undefined;
        if (Platform.OS === 'web') {
            const url = window.location.href;
            params = getParameters(url);
            const _ssoToken = params?.ssoToken;
            const _header = await getAuthHeaders();
            if (_ssoToken) {
                removeUrlWithoutReload("ssoToken");
                const response = await network.post(`${partnerApi?.getPartnerTokenFromSso}`, {
                    ssoToken: _ssoToken
                }, {
                    headers: _header
                }, async () => { return; }, {
                    isPartnerPlatform: true,
                    disableDefault: true
                });
                console.log("response: ", response);
                if (response?.status === 200) {
                    setTimeout(async () => {
                        const authToken = response?.data?.authToken;
                        await asyncStorage.set(StoreKey.accessToken, authToken);
                        await sharedPropsService.setToken(authToken);
                        const header = await getAppHeader();
                        header['X-AppPlatform'] = 'VOLT_WEB_APP';
                        const partnerContext_response = await network.post(partnerApi.userContext, {}, { headers: header }, async () => {
                            return;
                        }, {
                            isPartnerPlatform: true,
                        });
                        if (partnerContext_response["status"] === 200) {
                            const _user = partnerContext_response?.data;
                            await asyncStorage.set(StoreKey.userContext, JSON.stringify(_user));
                            return await navigateByUrl(ROUTE.PARTNER_LEAD, openNewTab);
                        }
                    }, 3000);
                }
            }
        }
        return Promise.resolve(template());
    },
    actions: {
    // [ACTION.YES_ACTION]: YesAction,
    // [ACTION.NO_ACTION]: NoAction
    },
};
